<div class="">
    <div *ngIf="busy" class="loading-indicator">
        <p-progressSpinner></p-progressSpinner>
    </div>

    <div *ngIf="error" class="error-message">
        <p-message severity="error" [text]="error"></p-message>
    </div>

    <div *ngIf="initialized && !busy" class="grid">
        <div class="col-7">
            <bm-payment-plan-activity></bm-payment-plan-activity>
        </div>
        <div class="col-5">

            <div class="sticky" style="top: 6rem">
                <p-card>

                    <p-tabs [(value)]="activeTab">
                        <p-tablist>
                            <p-tab value="0">Invoice Overview</p-tab>
                            @if (selectedContract) {
                                <p-tab value="1">
                                    <div class="flex align-items-center gap-2">
                                        <span>Contract</span>

                                        <i
                                                class="pi pi-times text-sm cursor-pointer opacity-70 hover:opacity-100"
                                                (click)="closeContractToolbar(); $event.stopPropagation()"
                                                aria-label="Close contract tab"
                                                role="button"
                                                tabindex="0">
                                        </i>
                                    </div>
                                </p-tab>
                            }
                        </p-tablist>
                        <p-tabpanels>
                            <p-tabpanel value="0">
                                <bm-payment-plan-balance
                                ></bm-payment-plan-balance>
                            </p-tabpanel>
                            <!-- RIGHT TOOLBAR -->
                            @if (selectedContract) {
                                <p-tabpanel value="1">

                                    @if (selectedContract) {
                                        <mvs-object
                                                style="height: calc(100vh - 18vh); overflow: auto; display: block;"
                                                objectType="cm.Contract"
                                                [objectId]="51355"
                                                uiMode="mini-side"
                                        ></mvs-object>
                                    }


                                    <!--                                    <bm-contract-toolbar-->
                                    <!--                                            style="height: calc(100vh - 18vh); overflow: auto; display: block;"-->
                                    <!--                                            [contract]="selectedContract"-->
                                    <!--                                            (close)="closeContractToolbar()">-->
                                    <!--                                    </bm-contract-toolbar>-->
                                </p-tabpanel>
                            }
                        </p-tabpanels>
                    </p-tabs>

                </p-card>
            </div>
        </div>

    </div>
</div>
